var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0233 23.9513C11.3049 23.9513 8.5866 23.5196 6.00826 22.6562C5.02826 22.3179 4.2816 21.6296 3.95493 20.7313C3.6166 19.8329 3.73326 18.8412 4.26993 17.9546L5.6116 15.7262C5.8916 15.2596 6.14826 14.3263 6.14826 13.7779V10.4062C6.14826 6.06625 9.68326 2.53125 14.0233 2.53125C18.3633 2.53125 21.8983 6.06625 21.8983 10.4062V13.7779C21.8983 14.3146 22.1549 15.2596 22.4349 15.7379L23.7649 17.9546C24.2666 18.7946 24.3599 19.8096 24.0216 20.7313C23.6833 21.6529 22.9483 22.3529 22.0266 22.6562C19.4599 23.5196 16.7416 23.9513 14.0233 23.9513ZM14.0233 4.28125C10.6516 4.28125 7.89826 7.02292 7.89826 10.4062V13.7779C7.89826 14.6296 7.54826 15.8896 7.1166 16.6246L5.77493 18.8529C5.51826 19.2846 5.44826 19.7396 5.59993 20.1246C5.73993 20.5212 6.08993 20.8246 6.56826 20.9879C11.4449 22.6212 16.6133 22.6212 21.4899 20.9879C21.9099 20.8479 22.2366 20.5329 22.3883 20.1129C22.5399 19.6929 22.5049 19.2379 22.2716 18.8529L20.9299 16.6246C20.4866 15.8662 20.1483 14.6179 20.1483 13.7662V10.4062C20.1483 7.02292 17.4066 4.28125 14.0233 4.28125Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1934 4.59695C16.1117 4.59695 16.0301 4.58529 15.9484 4.56195C15.6101 4.46862 15.2834 4.39862 14.9684 4.35195C13.9767 4.22362 13.0201 4.29362 12.1217 4.56195C11.7951 4.66695 11.4451 4.56195 11.2234 4.31695C11.0017 4.07195 10.9317 3.72195 11.0601 3.40695C11.5384 2.18195 12.7051 1.37695 14.0351 1.37695C15.3651 1.37695 16.5317 2.17029 17.0101 3.40695C17.1267 3.72195 17.0684 4.07195 16.8467 4.31695C16.6717 4.50362 16.4267 4.59695 16.1934 4.59695Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0234 26.6113C12.8684 26.6113 11.7484 26.1447 10.9318 25.328C10.1151 24.5113 9.64844 23.3913 9.64844 22.2363H11.3984C11.3984 22.9247 11.6784 23.6013 12.1684 24.0913C12.6584 24.5813 13.3351 24.8613 14.0234 24.8613C15.4701 24.8613 16.6484 23.683 16.6484 22.2363H18.3984C18.3984 24.6513 16.4384 26.6113 14.0234 26.6113Z",
    fill: "#1A1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.67cb8f4e2164ffb5a1b95dd9c012aac5.svg";
export { ForwardRef as ReactComponent };